import { configureTokenStore } from './tokenStore';

/**
 * One-time API layer configuration, applied at startup.
 *
 * The refresh token is carried in an httpOnly, Secure, SameSite=Strict cookie
 * that the backend sets on /auth/login, /auth/2fa/verify and /auth/refresh, and
 * clears on /auth/logout. The token is therefore unreadable from JavaScript:
 * `getRefreshToken()` returns null in this mode, nothing is written to
 * `sessionStorage`, and the client simply sends `credentials: 'include'` so the
 * browser attaches the cookie itself.
 *
 * This closes the weakest point in the auth story. With the token in
 * `sessionStorage`, one XSS anywhere in the app walked away with thirty days of
 * access and every other control — Argon2id, TOTP, rotation, reuse detection —
 * was bypassed by a single `getItem`. An XSS can still act as the user while it
 * is running on the page, but it cannot take the credential with it.
 */
export function configureNovixApi(): void {
  configureTokenStore({ refreshTransport: 'cookie' });
}
